import { Navigate, useLocation, useParams } from "react-router-dom"
import { FEATURE_PAGE_PATH } from "@/v2-backoffice-client/translation/translation.constants"

/**
 * Sends an old /translation/<view> link to its /features/<view> equivalent,
 * carrying the query string so a category deep link
 * (?category=UI_Dataset) still lands on the slice it named.
 *
 * The view ids never changed — only the path did — so this is a pure prefix
 * swap rather than a mapping table.
 */
function TranslationRedirect() {
  const { view } = useParams()
  const { search } = useLocation()

  return <Navigate to={`${FEATURE_PAGE_PATH}/${view}${search}`} replace />
}

export default TranslationRedirect
